import { render, staticRenderFns } from "./PriceListItem.vue?vue&type=template&id=5e6b91ac&"
import script from "./PriceListItem.vue?vue&type=script&lang=js&"
export * from "./PriceListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports